import state from "./moduleUserViewState.js";
import mutations from "./moduleUserViewMutations.js";
import actions from "./moduleUserViewActions.js";
import getters from "./moduleUserViewGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
